module.exports = __webpack_public_path__ + "static/media/greenTick.93c35aba.svg";